export const STORY_BACKGROUNDS = [
  { key: "emerald", label: "ירוק", style: { background: "linear-gradient(160deg, #047857 0%, #0f766e 45%, #0f172a 100%)" } },
  { key: "sunset", label: "שקיעה", style: { background: "linear-gradient(160deg, #f97316 0%, #e11d48 50%, #6b21a8 100%)" } },
  { key: "ocean", label: "ים", style: { background: "linear-gradient(160deg, #38bdf8 0%, #2563eb 50%, #1e3a8a 100%)" } },
  { key: "midnight", label: "לילה", style: { background: "linear-gradient(160deg, #1e1b4b 0%, #312e81 50%, #020617 100%)" } },
  { key: "berry", label: "יין", style: { background: "linear-gradient(160deg, #db2777 0%, #9d174d 55%, #3b0764 100%)" } },
  { key: "gold", label: "זהב", style: { background: "linear-gradient(160deg, #fbbf24 0%, #d97706 50%, #7c2d12 100%)" } },
  { key: "mint", label: "מנטה", style: { background: "linear-gradient(160deg, #6ee7b7 0%, #14b8a6 50%, #115e59 100%)" } },
  { key: "slate", label: "אפור", style: { background: "linear-gradient(160deg, #94a3b8 0%, #475569 50%, #0f172a 100%)" } },
  { key: "fire", label: "אש", style: { background: "linear-gradient(160deg, #facc15 0%, #ea580c 45%, #7f1d1d 100%)" } },
  { key: "royal", label: "סגול", style: { background: "linear-gradient(160deg, #a78bfa 0%, #7c3aed 50%, #1e1b4b 100%)" } },
  { key: "solid", label: "צבע", style: null },
];

export function resolveBackground(update = {}) {
  if (update.bg_key === "solid") {
    return { background: update.bg_color || "#0f766e" };
  }
  const preset = STORY_BACKGROUNDS.find((item) => item.key === update.bg_key) || STORY_BACKGROUNDS[0];
  return preset.style;
}
